var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1520 853 18 15.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: 0.32;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_1159226_cc",
    className: "cls-1",
    transform: "translate(2525.575 -120.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(-1005.575 973.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M-902.85,985.237A12.429,12.429,0,0,0-906.636,982l-1.855,1.855a3.547,3.547,0,0,1,.435,1.742,3.656,3.656,0,0,1-3.653,3.654,3.655,3.655,0,0,1-1.742-.435l-1.249,1.249a10.557,10.557,0,0,0,2.991.435,11.537,11.537,0,0,0,8.878-4.543A.661.661,0,0,0-902.85,985.237Z",
    transform: "translate(920.734 -978.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M-940.787,981.725a3.527,3.527,0,0,1-.435-1.723,3.644,3.644,0,0,1,3.653-3.654,3.655,3.655,0,0,1,1.742.435l1.249-1.249a10.557,10.557,0,0,0-2.991-.435,11.536,11.536,0,0,0-8.878,4.543.57.57,0,0,0,0,.719,12.429,12.429,0,0,0,3.786,3.237Z",
    transform: "translate(946.575 -972.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M-913,989.65a2.314,2.314,0,0,0,.189.965l3.426-3.426a2.74,2.74,0,0,0-.965-.189A2.658,2.658,0,0,0-913,989.65Z",
    transform: "translate(919.356 -982.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M-903.135,999.516a2.658,2.658,0,0,0,2.65-2.65,2.374,2.374,0,0,0-.189-.965l-3.426,3.426A2.657,2.657,0,0,0-903.135,999.516Z",
    transform: "translate(912.14 -989.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M-923.944,961.21a.628.628,0,0,0-.89,0l-13.857,13.857a.628.628,0,0,0,0,.89.615.615,0,0,0,.454.189.616.616,0,0,0,.454-.189l13.857-13.857A.647.647,0,0,0-923.944,961.21Z",
    transform: "translate(940.333 -961.025)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledIcon);
export default __webpack_public_path__ + "static/media/disabled_icon.de53edc20879f3a3fcd7cf17ecbd5825.svg";
export { ForwardRef as ReactComponent };